import { API_URLs } from "../../../utilities/API_URLs";
import { Http } from "../../../utilities/axios/http";

export class DashboardService {
  static getNumberOperations = async (year?: number) => {
    try {
      const res = await Http.get(
        API_URLs.dashboard.getNumberOperations,
        year ? { year } : {}
      );
      return res.data;
    } catch (error) {
      return null;
    }
  };

  static getOperationDistribution = async (year?: number) => {
    try {
      const res = await Http.get(
        API_URLs.dashboard.getOperationDistribution,
        year ? { year } : {}
      );
      return res.data;
    } catch (error) {
      return null;
    }
  };

  static getOperationalSummary = async () => {
    try {
      const res = await Http.get(API_URLs.dashboard.getOperationalSummary);
      return res.data;
    } catch (error) {
      return null;
    }
  };

  static getOperationFeatureList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.dashboard.getOperationaFeature, params);
    } catch (error) {
      return error;
    }
  };
}
